<template>
  <div class="content" :class="message.type">
    <span class="text" aria-live="polite" role="region">
      {{ message.text }}
    </span>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    message: {
      type: Object,
      required: true,
    },
    timeout: {
      type: String,
      required: true,
    },
  },
  emits: ['destroy'],
  created() {
    setTimeout(() => {
      this.$emit('destroy', '')
    }, this.timeout)
  },
}
</script>

<style lang="scss" scoped>
@include sr-only;
.content {
  margin-top: 12px;
  opacity: 1;
  max-height: 1000px;
  padding: 12px;
  pointer-events: auto;
  height: auto;
  background: #fc8826;
  color: white;
  box-shadow: $shadow-sm;
  border-radius: 1px;

  &:after {
    clear: both;
  }
}

.warning {
  background: #fc8826;
}

.success {
  background: rgba(76, 175, 80, 0.9);
}

.info {
  background: rgba(0, 0, 0, 0.8);
}

.text {
  padding: 0.25em;
  text-align: center;
}
</style>
